import { render, staticRenderFns } from "./headerScc.vue?vue&type=template&id=637904fe&scoped=true"
import script from "./headerScc.vue?vue&type=script&lang=js"
export * from "./headerScc.vue?vue&type=script&lang=js"
import style0 from "./headerScc.vue?vue&type=style&index=0&id=637904fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637904fe",
  null
  
)

export default component.exports